//import { MOCK_DATA } from "./mockData";

export const initialState = {
  articles: [],
  selectedArticles: [],
  totalAmount: 0,
  payment: null,
  captcha: null,
  internalId: null,
};
